import richText from "utilities/richText"

export default function TwoColumnSection({ blok }) {
  const columnStyles = "prose prose-h2:my-4 prose-h2:my-3 prose-ul:mb-0 prose-ul:marker:text-charcoal"

  return (
    <section className="two-column-section px-6 pb-10 pt-8 lg:pb-18">
      <div className="mx-auto w-full max-w-screen-xl">
        <h1 className="font-medium text-teal-dark">{blok.heading}</h1>
        <div className="flex flex-col gap-7 lg:flex-row lg:gap-x-12">
          <div className={columnStyles}>{richText(blok.column_1)}</div>
          <div className={columnStyles}>{richText(blok.column_2)}</div>
        </div>
      </div>
    </section>
  )
}
